import { z } from 'zod';
import { postRequest } from './amplify/helpers';

export const CompleteLlmTextSchema = z.object({
  prompt: z.string().min(1),
});

export type CompleteLlmTextRequest = z.infer<typeof CompleteLlmTextSchema>;

export type QueryGenerateLlmTextResponse = {
  text: string;
};

export type LLMCompletionResponse = {
  text: string;
  error: boolean;
};

export const completeLlmText = async (prompt: string): Promise<LLMCompletionResponse> => {
  try {
    const body = { prompt } satisfies CompleteLlmTextRequest;
    const response = (await postRequest({
      apiName: 'studio',
      path: '/llm/complete-text',
      options: {
        body,
      },
    })) satisfies QueryGenerateLlmTextResponse;

    return { text: response.text, error: false };
  } catch (e) {
    console.error('Error in completeLlmText:', e);
    return { text: '', error: true };
  }
};
